export const translations = {
  ko: {
    nav_videos: '콘텐츠',
    nav_how: '진행 방식',
    nav_inquiry: '차량 문의',
    nav_cta: '차량 문의하기 →',

    hero_badge: '한국 중고차 시장 전문 콘텐츠',
    hero_h1_1: '데이터로',
    hero_h1_2: '보는 한국',
    hero_h1_em: '중고차 시장',
    hero_sub: '숫자와 통계로 증명하는 한국 매물 분석.',
    hero_sub_strong: '구독하고, 신뢰가 생기면 문의하세요.',
    hero_sub2: '나머지는 저희가 직접 찾아드립니다.',
    hero_cta1: '무료 구독하기',
    hero_cta2: '최신 영상 보기',
    hero_subscribers: '구독 중',
    hero_new_badge: 'New Video',

    videos_tag: '콘텐츠 · Videos',
    videos_h2_1: '통계가 말하는',
    videos_h2_em: '한국 매물',
    videos_desc: '이 시장을 모르면 절대 줄 수 없는 분석. 숫자로 보여주는 한국 중고차 시장 인사이트.',
    videos_yt_cta: 'YouTube 채널 →',

    v1_tag: '📈 가격 트렌드',
    v1_title: '2026년 1분기 한국 중고차 가격 동향 — 연식별 하락폭 분석',
    v2_tag: '🔋 EV 특집',
    v2_title: '중동 바이어가 가장 많이 찾는 한국 전기차 TOP 5 — 실거래가 공개',
    v3_tag: '🏆 베스트 픽',
    v3_title: '주행거리 5만km 이하 SUV — 경매장 실거래 데이터 기반 추천',

    how_tag: '진행 방식',
    how_h2_1: '보고, 신뢰하고,',
    how_h2_em: '문의하세요',
    how_desc: '구독부터 실제 차량 상담까지, 단 4단계.',
    step1_title: '영상 구독',
    step1_desc: '통계 기반 한국 중고차 시장 분석 영상을 구독하고 시장을 파악하세요.',
    step2_title: '신뢰 형성',
    step2_desc: '콘텐츠를 보며 시장 전문성을 확인하고, A2G에 대한 신뢰를 쌓으세요.',
    step3_title: '차량 요청',
    step3_desc: '원하는 차량의 연식·차종·주행거리·상태·가격대를 양식에 작성해 보내주세요.',
    step4_title: '직접 상담',
    step4_desc: '전문가가 직접 한국 시장에서 조건에 맞는 매물을 찾아 1:1로 안내해 드립니다.',

    inq_tag: '차량 문의',
    inq_h2_1: '원하는 차량을',
    inq_h2_em: '알려주세요',
    inq_desc: '영상을 보고 관심이 생기셨나요? 조건을 보내주시면 저희가 직접 한국 시장에서 찾아드립니다. 무료입니다.',
    why1_title: '조건 맞춤 서치',
    why1_desc: '연식·주행거리·상태·가격대를 모두 고려해 최적의 매물을 직접 찾아드립니다.',
    why2_title: '1:1 전문가 상담',
    why2_desc: '경매장·딜러 네트워크를 활용해 시장 전문가가 직접 협상까지 지원합니다.',
    why3_title: '투명한 프로세스',
    why3_desc: '매물 발견부터 선적까지 전 과정을 바이어에게 공유합니다.',

    form_title: '차량 요청서',
    form_sub: '원하시는 차량 조건을 최대한 구체적으로 작성해 주세요. 24시간 내 전문가가 직접 연락드립니다.',
    form_sec1: '📋 연락처',
    form_sec2: '🚗 원하는 차량 조건',
    f_name: '이름 / Name',
    f_name_ph: '홍길동 / John Smith',
    f_country: '국가 / Country',
    f_country_ph: '선택...',
    f_country_other: '기타 / Other',
    f_email: '이메일 / Email',
    f_model: '차종 / Model',
    f_model_ph: '예) 제네시스 GV80, 아이오닉5',
    f_year: '연식 / Year',
    f_mileage: '최대 주행거리 / Max Mileage',
    f_condition: '차량 상태 / Condition',
    f_budget: '희망 가격대 / Budget Range',
    f_budget_min: '최소 (예: $10,000)',
    f_budget_max: '최대 (예: $25,000)',
    f_qty: '수량 / Quantity',
    f_notes: '추가 요청사항 / Additional Notes',
    f_notes_ph: '색상, 트림, 옵션, 희망 선적 시기 등 자유롭게 작성해 주세요...',
    f_select: '선택...',
    yr1: '2024년 이상', yr2: '2022 – 2023년', yr3: '2020 – 2021년',
    yr4: '2018 – 2019년', yr5: '2018년 이하', yr6: '연식 무관',
    ml1: '3만 km 이하', ml2: '5만 km 이하', ml3: '8만 km 이하',
    ml4: '10만 km 이하', ml5: '주행거리 무관',
    cd1: '최상 (무사고)', cd2: '상 (경미한 수리 가능)',
    cd3: '중 (수리 이력 있어도 가능)', cd4: '상태 무관 (가격 우선)',
    qt1: '1대', qt2: '2 – 5대', qt3: '6 – 10대', qt4: '10대 이상',
    form_submit: '문의 보내기 →',
    form_note: '무료 서비스입니다. 스팸 없이 담당자만 연락드립니다.',

    sub_tag: '뉴스레터 구독',
    sub_h2_1: '한국 시장 소식을',
    sub_h2_em: '가장 먼저',
    sub_h2_2: '받아보세요',
    sub_desc: '매주 한국 중고차 시장 통계, 가격 동향, 추천 매물을 영상과 리포트로 정리해 보내드립니다. 완전 무료입니다.',
    sub_ph: '이메일을 입력하세요',
    sub_btn: '구독하기',
    sub_note: '현재 1,240명이 구독 중 · 언제든 해지 가능',

    modal_inq_title: '문의가 접수됐습니다!',
    modal_inq_body: '24시간 내에 한국 시장 전문가가 직접 연락드릴 예정입니다. 감사합니다.',
    modal_sub_title: '구독 완료!',
    modal_sub_body: '한국 중고차 시장 최신 영상과 리포트를 보내드리겠습니다.',
    modal_close: '확인',
    modal_email_required: '이메일을 입력해 주세요.',
  },

  en: {
    nav_videos: 'Content',
    nav_how: 'How It Works',
    nav_inquiry: 'Vehicle Inquiry',
    nav_cta: 'Request a Vehicle →',

    hero_badge: 'Korean Used Car Market Expert Content',
    hero_h1_1: 'Data-Driven',
    hero_h1_2: 'Korean',
    hero_h1_em: 'Used Car Market',
    hero_sub: 'Market analysis backed by real numbers and statistics.',
    hero_sub_strong: 'Subscribe, build trust, then ask us to find your car.',
    hero_sub2: "We'll handle the rest.",
    hero_cta1: 'Subscribe Free',
    hero_cta2: 'Watch Latest',
    hero_subscribers: 'subscribers',
    hero_new_badge: 'New Video',

    videos_tag: 'Content · Videos',
    videos_h2_1: 'What the Numbers',
    videos_h2_em: 'Tell Us',
    videos_desc: "Insider analysis that only a true market expert can provide. Data-backed insights into the Korean used car market.",
    videos_yt_cta: 'YouTube Channel →',

    v1_tag: '📈 Price Trends',
    v1_title: 'Q1 2026 Korean Used Car Price Trends — Model Year Drop Rate Analysis',
    v2_tag: '🔋 EV Special',
    v2_title: 'Top 5 Korean EVs Most Sought by Middle East Buyers — Real Transaction Prices',
    v3_tag: '🏆 Best Picks',
    v3_title: 'SUVs Under 50,000km — Recommended Based on Auction Floor Transaction Data',

    how_tag: 'Process',
    how_h2_1: 'Watch, Trust,',
    how_h2_em: 'Request',
    how_desc: 'From subscribing to a real vehicle consultation — just 4 steps.',
    step1_title: 'Subscribe',
    step1_desc: 'Watch our statistics-based Korean used car market analysis videos and understand the market.',
    step2_title: 'Build Trust',
    step2_desc: 'Verify our market expertise through the content and develop confidence in A2G.',
    step3_title: 'Send a Request',
    step3_desc: 'Fill out the form with your desired vehicle\'s year, model, mileage, condition, and budget.',
    step4_title: 'Get Consultation',
    step4_desc: 'Our expert will search the Korean market directly and guide you 1-on-1 to the right vehicle.',

    inq_tag: 'Vehicle Inquiry',
    inq_h2_1: 'Tell Us What',
    inq_h2_em: 'You Want',
    inq_desc: 'Interested after watching our content? Send us your requirements and we\'ll find the right vehicle in Korea. Free of charge.',
    why1_title: 'Tailored Search',
    why1_desc: 'We search with all your criteria in mind — year, mileage, condition, and budget.',
    why2_title: '1-on-1 Expert Consultation',
    why2_desc: 'Our market specialist leverages auction and dealer networks to negotiate on your behalf.',
    why3_title: 'Transparent Process',
    why3_desc: 'We share every step with you, from finding the vehicle to shipping.',

    form_title: 'Vehicle Request Form',
    form_sub: 'Please describe your requirements as specifically as possible. Our expert will contact you within 24 hours.',
    form_sec1: '📋 Contact Info',
    form_sec2: '🚗 Vehicle Requirements',
    f_name: 'Name',
    f_name_ph: 'John Smith',
    f_country: 'Country',
    f_country_ph: 'Select...',
    f_country_other: 'Other',
    f_email: 'Email',
    f_model: 'Model',
    f_model_ph: 'e.g. Genesis GV80, Ioniq 5',
    f_year: 'Year',
    f_mileage: 'Max Mileage',
    f_condition: 'Condition',
    f_budget: 'Budget Range',
    f_budget_min: 'Min (e.g. $10,000)',
    f_budget_max: 'Max (e.g. $25,000)',
    f_qty: 'Quantity',
    f_notes: 'Additional Notes',
    f_notes_ph: 'Color, trim, options, desired shipping date, etc...',
    f_select: 'Select...',
    yr1: '2024 or newer', yr2: '2022 – 2023', yr3: '2020 – 2021',
    yr4: '2018 – 2019', yr5: '2017 or older', yr6: 'Any year',
    ml1: 'Under 30,000km', ml2: 'Under 50,000km', ml3: 'Under 80,000km',
    ml4: 'Under 100,000km', ml5: 'Any mileage',
    cd1: 'Excellent (Accident-free)', cd2: 'Good (Minor repairs OK)',
    cd3: 'Fair (Repair history OK)', cd4: 'Any condition (Price priority)',
    qt1: '1 unit', qt2: '2 – 5 units', qt3: '6 – 10 units', qt4: '10+ units',
    form_submit: 'Send Inquiry →',
    form_note: 'Free service. Only our specialist will contact you — no spam.',

    sub_tag: 'Newsletter',
    sub_h2_1: 'Get Korean Market',
    sub_h2_em: 'Insights',
    sub_h2_2: 'First',
    sub_desc: 'Weekly Korean used car market stats, price trends, and featured vehicles delivered as videos and reports. Completely free.',
    sub_ph: 'Enter your email',
    sub_btn: 'Subscribe',
    sub_note: '1,240 subscribers and growing · Unsubscribe anytime',

    modal_inq_title: 'Inquiry Received!',
    modal_inq_body: 'Our Korea market specialist will contact you within 24 hours. Thank you.',
    modal_sub_title: 'Subscribed!',
    modal_sub_body: "We'll send you the latest Korean used car market videos and reports.",
    modal_close: 'Got it',
    modal_email_required: 'Please enter your email.',
  },

  ru: {
    nav_videos: 'Контент',
    nav_how: 'Как это работает',
    nav_inquiry: 'Запрос авто',
    nav_cta: 'Запросить авто →',

    hero_badge: 'Экспертный контент о корейском рынке авто',
    hero_h1_1: 'Корейский',
    hero_h1_2: 'рынок б/у авто',
    hero_h1_em: 'в цифрах',
    hero_sub: 'Аналитика корейского авторынка на основе реальных данных и статистики.',
    hero_sub_strong: 'Подпишитесь, убедитесь в нашей экспертности и отправьте запрос.',
    hero_sub2: 'Мы найдём нужный автомобиль.',
    hero_cta1: 'Подписаться бесплатно',
    hero_cta2: 'Смотреть видео',
    hero_subscribers: 'подписчиков',
    hero_new_badge: 'Новое видео',

    videos_tag: 'Контент · Видео',
    videos_h2_1: 'Что говорит',
    videos_h2_em: 'статистика',
    videos_desc: 'Инсайдерская аналитика, доступная только эксперту рынка. Данные о корейском рынке б/у автомобилей.',
    videos_yt_cta: 'YouTube канал →',

    v1_tag: '📈 Тренды цен',
    v1_title: 'Цены на б/у авто в Корее Q1 2026 — анализ падения по годам выпуска',
    v2_tag: '🔋 Электромобили',
    v2_title: 'ТОП-5 корейских электромобилей для покупателей с Ближнего Востока — реальные цены',
    v3_tag: '🏆 Лучший выбор',
    v3_title: 'Внедорожники до 50 000 км — рекомендации на основе аукционных данных',

    how_tag: 'Процесс',
    how_h2_1: 'Смотрите, доверяйте,',
    how_h2_em: 'отправьте запрос',
    how_desc: 'От подписки до реальной консультации — всего 4 шага.',
    step1_title: 'Подписка',
    step1_desc: 'Смотрите аналитические видео о корейском рынке б/у авто и изучайте рынок.',
    step2_title: 'Доверие',
    step2_desc: 'Убедитесь в нашей экспертности через контент и сформируйте доверие к A2G.',
    step3_title: 'Отправьте запрос',
    step3_desc: 'Заполните форму: год выпуска, модель, пробег, состояние и ценовой диапазон.',
    step4_title: 'Консультация',
    step4_desc: 'Наш эксперт лично найдёт подходящий автомобиль на корейском рынке и проведёт консультацию 1:1.',

    inq_tag: 'Запрос автомобиля',
    inq_h2_1: 'Скажите нам,',
    inq_h2_em: 'что вы ищете',
    inq_desc: 'Заинтересовались после просмотра наших видео? Отправьте требования — мы найдём автомобиль в Корее бесплатно.',
    why1_title: 'Поиск по параметрам',
    why1_desc: 'Учитываем год, пробег, состояние и бюджет — находим лучший вариант.',
    why2_title: 'Консультация 1:1',
    why2_desc: 'Эксперт использует сети аукционов и дилеров, ведёт переговоры от вашего имени.',
    why3_title: 'Прозрачный процесс',
    why3_desc: 'Информируем вас на каждом этапе — от поиска автомобиля до отгрузки.',

    form_title: 'Форма запроса автомобиля',
    form_sub: 'Опишите требования как можно подробнее. Наш эксперт свяжется с вами в течение 24 часов.',
    form_sec1: '📋 Контактные данные',
    form_sec2: '🚗 Требования к автомобилю',
    f_name: 'Имя',
    f_name_ph: 'Иван Иванов',
    f_country: 'Страна',
    f_country_ph: 'Выберите...',
    f_country_other: 'Другая',
    f_email: 'Email',
    f_model: 'Модель',
    f_model_ph: 'напр. Genesis GV80, Ioniq 5',
    f_year: 'Год выпуска',
    f_mileage: 'Макс. пробег',
    f_condition: 'Состояние',
    f_budget: 'Ценовой диапазон',
    f_budget_min: 'Мин. (напр. $10,000)',
    f_budget_max: 'Макс. (напр. $25,000)',
    f_qty: 'Количество',
    f_notes: 'Дополнительные пожелания',
    f_notes_ph: 'Цвет, комплектация, опции, желаемая дата отгрузки и т.д...',
    f_select: 'Выберите...',
    yr1: '2024 и новее', yr2: '2022 – 2023', yr3: '2020 – 2021',
    yr4: '2018 – 2019', yr5: '2017 и старше', yr6: 'Любой год',
    ml1: 'До 30 000 км', ml2: 'До 50 000 км', ml3: 'До 80 000 км',
    ml4: 'До 100 000 км', ml5: 'Любой пробег',
    cd1: 'Отличное (без аварий)', cd2: 'Хорошее (мелкий ремонт допустим)',
    cd3: 'Среднее (история ремонта допустима)', cd4: 'Любое (главное — цена)',
    qt1: '1 авто', qt2: '2 – 5 авто', qt3: '6 – 10 авто', qt4: 'Более 10 авто',
    form_submit: 'Отправить запрос →',
    form_note: 'Бесплатная услуга. Свяжется только наш специалист — без спама.',

    sub_tag: 'Подписка на новости',
    sub_h2_1: 'Получайте инсайты',
    sub_h2_em: 'первыми',
    sub_h2_2: '',
    sub_desc: 'Еженедельная статистика, ценовые тренды и рекомендуемые автомобили в формате видео и отчётов. Абсолютно бесплатно.',
    sub_ph: 'Введите ваш email',
    sub_btn: 'Подписаться',
    sub_note: '1 240 подписчиков · Отписаться можно в любое время',

    modal_inq_title: 'Запрос принят!',
    modal_inq_body: 'Наш эксперт по корейскому рынку свяжется с вами в течение 24 часов. Спасибо.',
    modal_sub_title: 'Подписка оформлена!',
    modal_sub_body: 'Будем присылать последние видео и отчёты о корейском рынке б/у авто.',
    modal_close: 'Понятно',
    modal_email_required: 'Введите email.',
  },
}

export const SUPPORTED_LANGS = ['ko', 'en', 'ru']

export function detectLang() {
  const browserLang = navigator.language?.toLowerCase() || 'en'
  if (browserLang.startsWith('ko')) return 'ko'
  if (browserLang.startsWith('ru')) return 'ru'
  return 'en'
}
